import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export function downloadAtivosDaUsinaCsv(
  data: (string | number | null | undefined)[][],
  fileName: string = "ativos_da_usina"
) {
  const worksheet = XLSX.utils.aoa_to_sheet(data);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "ativosdausina");

  const excelBuffer = XLSX.write(workbook, { bookType: "csv", type: "array" });

  const dataBlob = new Blob([excelBuffer], { type: "text/csv;charset=utf-8" });

  saveAs(dataBlob, `${fileName}.csv`);
}
